export default {
  isShowLoader: false,
  config: null
};
